/* eslint-disable func-names */
import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

import {
  getAccessToken, cleanUpStorage
} from './storage';

import PATHS from 'utils/paths';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  ($config: AxiosRequestConfig): AxiosRequestConfig => {
    if ($config.headers) {
      const token = getAccessToken();
      if (token) {
        $config.headers.Authorization = `Bearer ${token}`;
      }
      $config.headers['Content-Type'] = 'application/json';
      $config.headers.Accept = 'application/json';
    }
    return $config;
  },
  async (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  async (error: AxiosError): Promise<AxiosError> => {
    if (error.response && error.response.status === 401) {
      cleanUpStorage();
      window.location.replace(PATHS.NEWS_PROMOTIONS);
    }
    return Promise.reject(error);
  },
);
export default axiosInstance;
